export default {"src":"/_next/static/media/where.c93ab061.svg","height":464,"width":474};